import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../utils/api';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import './ChangePassword.css';

export const ChangePassword = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isGerman = i18n.language === 'de';
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const togglePassword = (field) => {
    setShowPasswords({
      ...showPasswords,
      [field]: !showPasswords[field]
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      toast.error(isGerman ? 'Passwörter stimmen nicht überein' : 'Passwords do not match');
      return;
    }

    if (formData.new_password.length < 8) {
      toast.error(isGerman ? 'Passwort muss mindestens 8 Zeichen lang sein' : 'Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    try {
      await authAPI.changePassword({
        current_password: formData.current_password,
        new_password: formData.new_password,
      });

      toast.success(isGerman ? 'Passwort erfolgreich geändert' : 'Password changed successfully');
      navigate('/profile');
    } catch (error) {
      const message = error.response?.data?.detail || (isGerman ? 'Passwort ändern fehlgeschlagen' : 'Failed to change password');
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-container">
        <div className="change-password-card">
          <h1>{isGerman ? 'Passwort ändern' : 'Change Password'}</h1>

          <form onSubmit={handleSubmit} className="password-form">
            <div className="form-group">
              <label htmlFor="current_password">{isGerman ? 'Aktuelles Passwort' : 'Current Password'}</label>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  type={showPasswords.current ? "text" : "password"}
                  id="current_password"
                  name="current_password"
                  value={formData.current_password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                  style={{ paddingRight: '3.5rem', width: '100%' }}
                />
                <button
                  type="button"
                  onClick={() => togglePassword('current')}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.75rem',
                    padding: '0.25rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                    width: '2.5rem',
                    height: '2.5rem',
                    zIndex: 10,
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1)'}
                >
                  {showPasswords.current ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="new_password">{isGerman ? 'Neues Passwort' : 'New Password'}</label>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  type={showPasswords.new ? "text" : "password"}
                  id="new_password"
                  name="new_password"
                  value={formData.new_password}
                  onChange={handleChange}
                  required
                  minLength="8"
                  autoComplete="new-password"
                  style={{ paddingRight: '3.5rem', width: '100%' }}
                />
                <button
                  type="button"
                  onClick={() => togglePassword('new')}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.75rem',
                    padding: '0.25rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                    width: '2.5rem',
                    height: '2.5rem',
                    zIndex: 10,
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1)'}
                >
                  {showPasswords.new ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="confirm_password">{isGerman ? 'Passwort bestätigen' : 'Confirm Password'}</label>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  type={showPasswords.confirm ? "text" : "password"}
                  id="confirm_password"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  required
                  minLength="8"
                  autoComplete="new-password"
                  style={{ paddingRight: '3.5rem', width: '100%' }}
                />
                <button
                  type="button"
                  onClick={() => togglePassword('confirm')}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.75rem',
                    padding: '0.25rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                    width: '2.5rem',
                    height: '2.5rem',
                    zIndex: 10,
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(-50%) scale(1)'}
                >
                  {showPasswords.confirm ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                onClick={() => navigate('/profile')}
                className="button secondary"
              >
                {isGerman ? 'Abbrechen' : 'Cancel'}
              </button>
              <button
                type="submit"
                className="button primary"
                disabled={loading}
                data-testid="change-password-submit"
              >
                {loading ? (isGerman ? 'Lädt...' : 'Loading...') : (isGerman ? 'Speichern' : 'Save')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
